export const batchSearchProgressModalReducerKey = 'batchSearchProgressModalReducerKey';
export const batchSearchProgressModalSetProgressStatusReducerType = 'batchSearchProgressModalSetProgressStatusReducerType';
export const batchSearchProgressModalSetQueryRunningReducerType = 'batchSearchProgressModalSetQueryRunningReducerType';
export const batchSearchProgressModalSetQueriesTotalReducerType = 'batchSearchProgressModalSetQueriesTotalReducerType';
export const batchSearchProgressModalSetStatusReducerType = 'batchSearchProgressModalSetStatusReducerType';
export const batchSearchProgressModalSetProgressPercentageReducerType = 'batchSearchProgressModalSetProgressPercentageReducerType';

export const BATCH_SEARCH_PROGRESS_MODAL_STATUS = {
  RUNNING: 'running',
  COMBINING: 'combining',
};

export const typeOfBatchSearchProgressModal = 'typeOfBatchSearchProgressModal';
